export const FLAT_PERCENTAGE = "FLAT_PERCENTAGE";
export const SPREAD_MAINTENANCE = "SPREAD_MAINTENANCE";
export const MAKE_WHOLE = "MAKE_WHOLE";
export const DEFEASANCE = "DEFEASANCE";
export const YIELD_MAINTENANCE_TRADITIONAL = "YIELD_MAINTENANCE_TRADITIONAL";
export const YIELD_MAINTENANCE_AGENCY_STYLE = "YIELD_MAINTENANCE_AGENCY_STYLE";
export const AGGREGATE_INTEREST = "AGGREGATE_INTEREST";
export default {
  FLAT_PERCENTAGE,
  SPREAD_MAINTENANCE,
  MAKE_WHOLE,
  DEFEASANCE,
  YIELD_MAINTENANCE_TRADITIONAL,
  YIELD_MAINTENANCE_AGENCY_STYLE,
  AGGREGATE_INTEREST
};
